import { Box, Button, TextField } from '@mui/material';
import React from 'react';
import { FilterTree } from './FilterTree';
import { FolderTreeNode, TreeLabelBaseProperties } from './types';

export const FilterPopoverContent: React.FC<{
  showFilterInput: boolean | undefined;
  filterName?: string;
  filteredTree: FolderTreeNode[];
  filterInputValue: string;
  setFilterInputValue: (value: string) => void;
  selectedItems: string;
  setSelectedItems: (value: string) => void;
  expandedItems: string[];
  setExpandedItems: (value: string[]) => void;
  renderLabel: (properties: TreeLabelBaseProperties) => React.ReactNode;
  isDeferredApply?: boolean;
  onApply: () => void;
}> = ({
  showFilterInput,
  filterName,
  filteredTree,
  filterInputValue,
  setFilterInputValue,
  selectedItems,
  setSelectedItems,
  expandedItems,
  setExpandedItems,
  renderLabel,
  isDeferredApply,
  onApply,
}) => {
  return (
    <Box sx={{ maxHeight: 410, padding: '16px', display: 'flex', flexDirection: 'column', gap: 1 }}>
      {showFilterInput && (
        <TextField
          fullWidth
          size='small'
          placeholder={`Filter ${filterName}`}
          value={filterInputValue}
          onChange={event => setFilterInputValue(event.target.value)}
          sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: '6px' } }}
          autoFocus
        />
      )}
      <Box sx={{ flex: 1, minHeight: 0, marginLeft: '-16px', overflowY: 'auto' }}>
        <FilterTree
          nodes={filteredTree}
          selectedItems={selectedItems}
          onSelectedItemsChange={setSelectedItems}
          expandedItems={expandedItems}
          onExpandedItemsChange={setExpandedItems}
          renderLabel={renderLabel}
          sx={{
            '& .MuiBox-root': { gap: 0 },
            '& .MuiCheckbox-root, & .MuiRadio-root': { padding: '4px' },
            '& .MuiTreeItem-label': {
              fontSize: '14px',
              color: 'text.primary',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '100%',
              display: 'block',
            },
            '& .MuiTreeItem-iconContainer': { color: 'text.primary' },
            '& .MuiTreeItem-content': {
              gap: '0',
              paddingTop: '0',
              paddingBottom: '0',
              border: 'none',
              width: '100%',
              '&.Mui-selected': {
                backgroundColor: 'transparent !important',
              },
              '&:hover': {
                backgroundColor: 'transparent !important',
              },
            },
            '& .Mui-selected': {
              backgroundColor: 'transparent !important',
              '&:hover': {
                backgroundColor: 'transparent !important',
              },
            },
          }}
        />
      </Box>
      {isDeferredApply && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
          <Button
            variant='contained'
            size='small'
            color='secondary'
            onClick={onApply}
            sx={{
              textTransform: 'none',
              borderRadius: '12px',
              padding: '8px 16px',
            }}
          >
            Apply
          </Button>
        </Box>
      )}
    </Box>
  );
};
